import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const bulkLoginUploadSlice = createSlice({
  name: "bulkLoginUploadReducer",
  initialState: { pageNo: 1, 
    pageSize: 10 ,
    searchParam: null, 
  },
  
  reducers: {
    setBulkLoginUploadPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setBulkLoginUploadPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setBulkLoginUploadSearchParam: (state, action: PayloadAction<any>) => {
      state.searchParam = action.payload;
    },
    
 }
});

export const {   
    setBulkLoginUploadPageNo,
    setBulkLoginUploadPageSize,
    setBulkLoginUploadSearchParam,  
   } = bulkLoginUploadSlice.actions;
export default bulkLoginUploadSlice.reducer;